import OrderStatuses from "@src/constants/OrderStatuses";
import { formatDateShort } from "./formatDate";

export const getOrderStatusDisplay = (status: string, timestamps: any) => {
  if (status === OrderStatuses.Delivered) {
    return `Delivered ${formatDateShort(timestamps.deliveredAtTimestamp)}`;
  }
  if (status === OrderStatuses.Shipped) {
    return `Shipped ${formatDateShort(timestamps.shippedAtTimestamp)}`;
  }
  if (status === OrderStatuses.Canceled) {
    return `Canceled ${formatDateShort(timestamps.canceledAtTimestamp)}`;
  }
  if (status === OrderStatuses.Returned) {
    return `Returned ${formatDateShort(timestamps.returnedAtTimestamp)}`;
  }
  if (status === OrderStatuses.Pending) {
    return `Ordered ${formatDateShort(timestamps.placedAtTimestamp)}`;
  }
  return status;
};
